import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum, FilterIdEnum } from '../../enums'

import FacetsForm from '../../views/facets/facets-form.view.vue'
import FacetsList from '../../views/facets/facets-list.view.vue'

import { ROUTER_CONSTS } from '../router.consts'
import { ENABLED_FILTER_CONFIG, ENDPOINT_FILTER_CONFIG } from '../routes.filters'
import { ROUTES_PATHS } from '../routes.paths'

const FACETS_PATHS = Object.assign(ROUTES_PATHS, {
  facets: 'facets',
})

export const FACETS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.FACETS].list,
    path: FACETS_PATHS.facets,
    component: FacetsList,
    meta: {
      featureId: FeatureIdEnum.FACETS,
      browseListFilterEnabled: true,
      filters: () => ({
        regularFiltersEnabled: true,
        config: {
          [FilterIdEnum.LANG]: {
            multiselectDisabled: true,
          },
        },
        extra: {
          [ENDPOINT_FILTER_CONFIG.id]: ENDPOINT_FILTER_CONFIG,
          [ENABLED_FILTER_CONFIG.id]: ENABLED_FILTER_CONFIG,
        },
      }),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.FACETS].create,
    path: `${FACETS_PATHS.facets}/${FACETS_PATHS.actions.create}`,
    component: FacetsForm,
    meta: {
      featureId: FeatureIdEnum.FACETS,
      titleI18nKey: 'createFacets',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.FACETS].list,
    },
  },
  {
    name: ROUTER_CONSTS.routes[FeatureIdEnum.FACETS].update,
    path: `${FACETS_PATHS.facets}/${FACETS_PATHS.actions.update}`,
    component: FacetsForm,
    meta: {
      featureId: FeatureIdEnum.FACETS,
      titleI18nKey: 'updateFacets',
      parentRouteName: ROUTER_CONSTS.routes[FeatureIdEnum.FACETS].list,
    },
  },
]
